import { ServiceHandler } from '../../../utils/api.utils';
import type { CustomSkill } from '../types/custom-skill.types';

export const getCustomSkills = ServiceHandler<
  unknown,
  { skills: CustomSkill[] }
>({
  url: '/api/chat-agent/v1/custom-skills',
});

export const getCustomSkill = ServiceHandler<unknown, CustomSkill>({
  url: '/api/chat-agent/v1/custom-skills/:skillId',
});

export const createCustomSkill = ServiceHandler<Partial<CustomSkill>, CustomSkill>({
  url: '/api/chat-agent/v1/custom-skills',
  method: 'POST',
});

export const updateCustomSkill = ServiceHandler<Partial<CustomSkill>, CustomSkill>({
  url: '/api/chat-agent/v1/custom-skills/:skillId',
  method: 'PUT',
});

export const deleteCustomSkill = ServiceHandler<unknown, { deleted: boolean }>({
  url: '/api/chat-agent/v1/custom-skills/:skillId',
  method: 'DELETE',
});

// Publishing is the trust boundary: a draft affects nobody, while a live skill
// enters the tenant catalog and becomes attachable to agents. The backend
// re-runs its author-capability clamps on publish, so these can be rejected.
export const publishCustomSkill = ServiceHandler<unknown, CustomSkill>({
  url: '/api/chat-agent/v1/custom-skills/:skillId/publish',
  method: 'POST',
});

export const unpublishCustomSkill = ServiceHandler<unknown, CustomSkill>({
  url: '/api/chat-agent/v1/custom-skills/:skillId/unpublish',
  method: 'POST',
});
